export { default } from "./ExcludeItemsLabels";
